/**
 * Images :: Interfaces + Types
 */

export interface IApiObject<T> {
	data?: T;
	failureActions?: any[];
	messages?: any[];
	success?: boolean;
	successfulActions?: any[];
}

export interface ICollectionList<T>{
	pages?: T;
	currentPage?: number;
	endPage?: number;
	k5appropriate?: boolean;
	pageSize?: number|string;
	startPage?: number;
	totalItems?: number;
	totalPages?: number;
	keywords?: string;
	sortBy?: string;
	slideShowforAllImages?:boolean;
	filterConfig?: any;
	keywordConfig?: any;
	allRecords?:boolean;
}

export interface IImage {
	imageID?: string; // primary key
	imageSets?: any[]; // many-to-many
	arrayImageSetIDs?: string[];
	additionalArtistDates?: string;
	additionalArtists?: string;
	artistCulture?: string;
	artistDates?: string;
	artistName?: string;
	artisticForm?: string;
	artisticStyle?: string;
	calculatedAssignedSkuCodeList?: string;
	calculatedAssignedSkuIDList?: string;
	daiCatalogNumber?: string;
	directory?: string;
	height?: string|number;
	heightFormatted?: string|number;
	imageAdditionalDescription?: string;
	imageCredits?: string;
	imageCreditsFormatted?: string;
	imageDescription?: string;
	imageFile?: string;
	imageKeywords?: string;
	imageMetaData?: string;
	imageName?: string;
	imageSource?: string;
	k5EligibleFlag?: string|boolean;
	museum?: string;
	originalExhibitionDate?: string;
	originalWorkAccession?: string;
	originalWorkCity?: string;
	originalWorkDate?: string;
	originalWorkDepth?: string;
	originalWorkDuration?: string;
	originalWorkMaterial?: string;
	originalWorkMedium?: string;
	originalWorkPeriod?: string;
	originalWorkSize?: string;
	originalWorkSubject?: string;
	originalWorkSupport?: string;
	s3PathToImageFile?: string;
	tiffImageFile?: string;
	width?: string|number;
	widthFormatted?: string|number;
	remoteID?: string;
	createdDateTime?: string;
	createdByAccountID?: string;
	modifiedDateTime?: string;
	modifiedByAccountID?: string;
	isNew?: boolean;
	exists?: boolean;
}

export interface IImageSet {
	imageSetID?: string; // primary key
	images?: ImageCollectionList; // many-to-many
	arrayImageIDs?: string[];
	backgroundColor?: string;
	collegeFlag?: boolean;
	daiCatalogNumber?: string;
	daiImageSetFlag?: boolean;
	description?: string;
	k12Flag?: boolean;
	position?: number;
	title?: string;
	remoteID?: string;
	createdDateTime?: string;
	createdByAccountID?: string;
	modifiedDateTime?: string;
	modifiedByAccountID?: string;
	isNew?: boolean;
	exists?: boolean;
	account_accountID?: string,
	account_firstName?: string,
	account_lastName?: string,
	accountRole?: string,
}

export interface IImageSetImage {
	imageSetID?: string;
	imageID?: string;
}

export interface ImageSetCollectionList extends ICollectionList<IImageSet[]> {
	davisCollectionsOnly?: boolean;
	bookCollectionsOnly?: boolean;
	myCollectionsOnly?: boolean;
	sharedCollectionsOnly?: boolean;
	sharedWithTeacher?: boolean;
	sharedWithStudent?: boolean;
	arrayImageIDs?: string[];
	coverImages?: ImageCollectionList;
}

export interface ImageCollectionList extends ICollectionList<IImage[]> {
	arrayImageIDs?:string[];
	arrayImageSetIDs?: string[];
	imageSetID?: string;
};

export interface Images extends IApiObject<ImageCollectionList> {};

export interface ImageSets extends IApiObject<ImageSetCollectionList> {};

export interface ImageTabClasses {
	imagesearch?: string;
	mycollections?: string;
	sharedcollections?: string;
	daviscolletions?: string;
};

export type ImageTab = 'imagesearch' | 'mycollections' | 'sharedcollections'| 'daviscollections' | 'bookcollections';